import React from 'react';
import { Link } from 'gatsby';

import { BlockWrapper } from '../blockWrapper';
import { GetEvents } from '@querys/getEvents';

const UpcomingEvents = ({ heading, blockConfig }) => {
  const events = GetEvents();
  const sortedEvents = events
    .sort((a, b) => new Date(a.session[0]) - new Date(b.session[0]))
    .filter((e) => e.where.title === 'Hanover Hall');

  return (
    <BlockWrapper
      {...blockConfig}
      className={`grid grid-cols-14 text-base leading-base ${
        sortedEvents.length === 0 && 'hidden'
      }`}>
      <h2 className='col-start-2 col-end-14 text-3xl leading-3xl md:text-5xl md:leading-5xl font-medium mb-8 lg:mb-20'>
        {heading}
      </h2>

      <span className='hidden lg:block col-start-2 col-end-5 font-semibold border-b border-grey pb-4'>
        Date
      </span>
      <span className='hidden lg:block col-start-5 col-end-12 font-semibold border-b border-grey pb-4'>
        Event
      </span>
      <span className='hidden lg:block col-start-12 col-end-14 font-semibold border-b border-grey pb-4 text-center'>
        Link
      </span>

      {sortedEvents.map((event, i) => {
        const { title, session, slug, where } = event || {};

        var now = new Date();
        var eventTime = new Date(session[session.length - 1]);
        var upcoming = eventTime.getTime() - now.getTime();

        const months = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        const day = session[0].slice(8, 10);
        const day2 = session[session.length - 1]?.slice(8, 10);
        const month = months[session[0].slice(5, 7) - 1];
        const month2 = months[session[session.length - 1]?.slice(5, 7) - 1];
        const year = session[0].slice(0, 4);

        if (upcoming > 0) {
          return (
            <div className='col-start-2 col-end-14 flex flex-col lg:grid grid-cols-12 text-base leading-base'>
              {session.length > 1 ? (
                <span className='col-start-1 col-end-4 font-semibold pt-4 lg:py-4 lg:border-b border-grey'>
                  {parseInt(day)} {month !== month2 && month} - {parseInt(day2)}{' '}
                  {month !== month2 ? month2 : month} {year}
                </span>
              ) : (
                <span className='col-start-1 col-end-4 font-semibold pt-4 lg:py-4 lg:border-b border-grey'>
                  {parseInt(day)} {month} {year}
                </span>
              )}
              <h4 className='col-start-4 col-end-11 lg:py-4 lg:border-b border-grey'>
                {title}
              </h4>
              <Link
                to={`/events/${slug.current}`}
                className='underline border-b border-grey pb-4 lg:py-4 col-start-11 col-end-13 text-center flex justify-self-start lg:block w-full'>
                View
              </Link>
            </div>
          );
        }
      })}
    </BlockWrapper>
  );
};

export default UpcomingEvents;
